import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';

// Keep types flat like GeneralTaskDTO
export interface DriverDTO {
  id?: string;
  tenantId: string;
  tenantName?: string;

  name: string;
  phone?: string;
  alternateNumber?: string;
  licenseNo: string;
  licenseValidTill: string; // ISO date string yyyy-MM-dd
  isActive?: boolean;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

const API_BASE = `${API_ENDPOINTS.vehicle}/drivers`;

export const DriverApi = {
  // Search (aligning to your POST /search style for complex filters)
  search: (filter: Partial<DriverDTO>, page = 0, size = 20, sort = 'name,asc') =>
    axios.get<PageResponse<DriverDTO>>(`${API_BASE}`, {
      params: {
        tenantId: filter.tenantId,
        name: filter.name,
        phone: filter.phone,
        licenseNo: filter.licenseNo,
        active: filter.isActive,
        page,
        size,
        sort,
      },
    }),

  get: (tenantId: string, id: string) =>
    axios.get<DriverDTO>(`${API_BASE}/${id}`, { params: { tenantId } }),

  create: (dto: DriverDTO) => axios.post<DriverDTO>(`${API_BASE}`, dto),

  update: (tenantId: string, id: string, dto: Partial<DriverDTO>) =>
    axios.put<DriverDTO>(`${API_BASE}/${id}`, dto, { params: { tenantId } }),

  remove: (tenantId: string, id: string) =>
    axios.delete<void>(`${API_BASE}/${id}`, { params: { tenantId } }),

  // Convenience: fetch all (limited)
  fetchAll: (tenantId: string, size = 200) =>
    axios.get<PageResponse<DriverDTO>>(`${API_BASE}`, {
      params: { tenantId, page: 0, size, sort: 'name,asc' },
    }),
};